import app from './app';

const i18n = {
  detect: () => {
    const i18n = localStorage.getItem('i18n');

    if (i18n !== 'en' && i18n !== 'fi') {
      if (navigator.language === 'en' || navigator.language.match(/^en\-(.+)/)) {
        app.run.i18n = 'en';
      } else if (navigator.language === 'fi' || navigator.language.match(/^fi\-(.+)/)) {
        app.run.i18n = 'fi';
      } else {
        app.run.i18n = 'en';
      }
    } else {
      app.run.i18n = 'en';
    }

    localStorage.setItem('i18n', app.run.i18n);
    console.log(`app-i18n-${app.run.i18n}`);
    //document.getElementById(`app-i18n-${app.run.i18n}`).classList.add('active');
  },

  render: () => {
    //document.title = app.run.settings.siteTitle;

    /*
    const title = `${app.run.settings.view[app.route].pageTitle}${app.run.settings.siteTitleSeparator}${app.run.settings.siteTitle}`;
    document.title = title;
    */

    let attribute = '';

    attribute = 'data-i18n';
    Array.from(document.querySelectorAll(`[${attribute}]`)).forEach((element) => {
      const attributeArray = element.getAttribute(attribute).split('-');
      element.innerHTML = app.run.settings[attributeArray[0]][attributeArray[1]][attributeArray[2]];
    });

    attribute = 'data-i18n-placeholder';
    Array.from(document.querySelectorAll(`[${attribute}]`)).forEach((element) => {
      const attributeArray = element.getAttribute(attribute).split('-');
      element.setAttribute('placeholder', app.run.settings[attributeArray[0]][attributeArray[1]][attributeArray[2]]);
    });
  },
};

export default i18n;
